<template>
    <section class="support_chat_ws">
        <div id="frame">
            <chat-user-list></chat-user-list>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
import chatUserList from "@/components/botTickets/workspace/chat-user-list.vue/";

const $ = window.jQuery = require('jquery');
export default {
  name: 'support-chat-workspace',
  components: {
    'chat-user-list': chatUserList
  },
  props: [],
  data() {
    return {
      chatRoomInfo: null,
      selfUserId: '',
    }
  },
  computed: {
  },
  mounted() {
    this.selfUserId = localStorage.getItem('LoginedUserID');
    bus.$emit('clearSChatCountBus', 0);
  },
  methods: {
  },
  watch: {
  },
  beforeCreate: function () {
    document.body.classList.add('workspace_main_page_wrp');
  },
  beforeRouteLeave(to, from, next) {
    document.body.classList.remove('workspace_main_page_wrp');
    setTimeout(() => {
      bus.$emit('supportWorkspaceRouterLeaveEvntBus', 'Router_leave')
    }, 100)
    next();
  },
}
</script>

<style lang="scss" scoped>
@import url("../../../assets/fonts/simplicity/stylesheet.css");
.support_chat_ws {
	font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
	padding: 20px;
  background: rgba(0, 0, 0, .6);
  border-radius: 3px;
  min-height: calc(100dvh - 80px);
  position: relative;
  width: 100%;
  margin-left: auto;
    #frame {
        width: 100%;
        height: calc(100dvh - 120px);
        margin: 0 auto;
        clear: both;
    }
}
</style>